import React, { PureComponent } from 'react';
import './category.list.component.style.css';

class CategoryItem extends PureComponent {
  state = {
    isSelected: false,
  };

  _onClick = () => {
    const { isSelected } = this.state;
    const { item, onChange } = this.props;
    this.setState({ isSelected: !isSelected }, () =>
      onChange(item, this.state.isSelected)
    );
  };

  render() {
    const { item } = this.props;
    const { isSelected } = this.state;

    return (
      <span
        className={`category-item ${
          isSelected ? 'category-item-selected' : 'category-item-unselected'
        } component-focus`}
        onClick={this._onClick}
      >
        {item.name}
      </span>
    );
  }
}

class CategoryList extends PureComponent {
  static Item = CategoryItem;

  render() {
    const { data, onChange } = this.props;
    return (
      <div className="category-list self-align-center flex-column align-stretch">
        <span style={{ margin: '10px auto' }}>Categorias</span>
        <div className="flex-row justify-center flex-wrap">
          {data && data.length > 0
            ? data.map((item, idx) => (
                <CategoryList.Item key={idx} item={item} onChange={onChange} />
              ))
            : null}
        </div>
      </div>
    );
  }
}

export default CategoryList;
